import { render, staticRenderFns } from "./Genera_vale2.vue?vue&type=template&id=06f88892&"
import script from "./Genera_vale2.vue?vue&type=script&lang=js&"
export * from "./Genera_vale2.vue?vue&type=script&lang=js&"
import style0 from "./Genera_vale2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports